import { setChatImagesEmpty } from './actions';
import { getChatImages } from './getChatImages';
import { TThunkAction } from '../../types/redux/thunk';

export interface IUpdateChatImagesAction {
  chatId: string;
  offset?: number;
}

export const updateChatImages =
  ({ chatId, offset }: IUpdateChatImagesAction): TThunkAction<void> =>
  dispatch => {
    if (!offset) {
      dispatch(setChatImagesEmpty({ chatId }));
    }

    dispatch(getChatImages(chatId, offset));
  };
